import React, { MouseEventHandler, ReactNode } from 'react';

interface LinkButtonProps {
  children: ReactNode;
  dataQa: string;
  as: 'div' | 'a';
  className: string;
  href?: string;
  onClick?: (() => void) | MouseEventHandler;
}

export function LinkButton({ as, children, dataQa, ...rest }: LinkButtonProps) {
  const Component = as;

  return (
    <Component {...rest} data-qa={dataQa}>
      {children}
    </Component>
  );
}
